import React from "react";
import {Helmet} from "react-helmet";
import {routes, site} from "../config";
import {metaDescriptions, metaTitles} from "../website-gridhaus/meta";
import {Link} from "react-router-dom";


export default class NotFoundPage extends React.Component {
  componentDidMount() {
    window.analytics.page("Not Found");
  }

  render() {
    window.prerenderReady = true;
    return (
      <div className={'page-not-found'}>
        <Helmet>
          <title>{site.titlePrefix + 'Page not found'}</title>
          {metaTitles(site.titlePrefix + 'Page not found')}
          {metaDescriptions('Page not found')}
          <meta name="prerender-status-code" content="404"/>
        </Helmet>
        <section className={'hero'} id={'hero'}>
          <div className={'container'}>
            <h1 className={'title'}>Well that's embarassing...</h1>
            <div className={'brief'}>
              <p>Error 404<br/>Page not found</p>
              <Link className={'link'} to={routes.home}>Back to Home</Link>
            </div>
          </div>
        </section>
      </div>
    )

  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js